import { ReactElement, useCallback } from 'react';
import { ClassroomsFilterData } from '../types';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { AxiosResultDefaultError } from '../../../../api/request';
import { getFiltersData } from '../api';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { Card } from 'reactstrap';

interface SearchControlsLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  ClassroomsFilterData,
  AxiosResultDefaultError
>();

export const useFormData = useFetch;

export const ClassroomsLoaderConsumer = FetchConsumer;

export function SearchControlsLoader({ children }: SearchControlsLoaderProps) {
  const request = useCallback(() => {
    return getFiltersData();
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={undefined}
      fetchImmediately={true}
    >
      <FetchConsumer>
        {({ loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <Card className="mx-3 p-4">
                <Loading insideCard />
              </Card>
            );
          }

          return children;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
